<div class="wrapper">
  <app-header></app-header>

  <main class="page">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>

<button class="scroll-top-btn" [class.scroll-top-visible]="showScrollTop()" (click)="scrollToTop()" aria-label="Scroll to top">
  <i class="fas fa-arrow-up"></i>
</button>
